export default "/images/forbes.svg?e05eb8d11a25c397d3b45c32eaf875ee";